import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header pb-0" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Pedidos")
], -1)
const _hoisted_3 = { class: "card-body px-0 pt-0 pb-2" }
const _hoisted_4 = {
  key: 0,
  class: "p-2 align-items-center ms-md-auto"
}
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text text-body" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-search",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_7 = {
  key: 1,
  class: "p-2 align-items-center ms-md-auto"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-4" }
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text text-body" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-search",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_12 = { class: "col-2" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Procurar ")
const _hoisted_14 = { class: "table-responsive p-0" }
const _hoisted_15 = { class: "table align-items-center mb-0" }
const _hoisted_16 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode()
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Loja ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-1" }, "Alocada", -1)
const _hoisted_22 = { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Cupom Fiscal")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Embalagens", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, " Veículo ", -1)
const _hoisted_26 = { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Janela Entrega ")
const _hoisted_28 = /*#__PURE__*/_createElementVNode("th", { class: "text-secondary opacity-7 text-xxs" }, "Em Rota", -1)
const _hoisted_29 = { class: "d-flex px-2 py-1" }
const _hoisted_30 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_31 = { class: "mb-0 text-sm" }
const _hoisted_32 = { class: "text-xs text-secondary mb-0" }
const _hoisted_33 = { class: "text-uppercase text-secondary text-xxs" }
const _hoisted_34 = { class: "text-secondary text-xs font-weight-bold" }
const _hoisted_35 = { class: "capacidade flex-column" }
const _hoisted_36 = { class: "tags-capacidade" }
const _hoisted_37 = ["onChange", "onUpdate:modelValue", "onKeydown"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "text-uppercase text-secondary text-xxs cupom" }
const _hoisted_40 = { class: "tags-capacidade" }
const _hoisted_41 = ["onUpdate:modelValue", "onChange", "onKeydown"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "text-center text-uppercase text-secondary text-xxs" }
const _hoisted_44 = { class: "tags-container" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onUpdate:modelValue", "onKeydown"]
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = {
  key: 1,
  class: "tag-erro"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { class: "text-sm justify-content-center flex-column" }
const _hoisted_52 = { class: "text-sm justify-content-center flex-column" }
const _hoisted_53 = {
  key: 0,
  class: "d-flex flex-column badge badge-sm bg-gradient-primary"
}
const _hoisted_54 = {
  key: 1,
  class: "d-flex flex-column badge badge-sm bg-gradient-danger"
}
const _hoisted_55 = {
  key: 2,
  class: "d-flex flex-column badge badge-sm bg-gradient-manual"
}
const _hoisted_56 = {
  key: 3,
  class: "d-flex flex-column badge badge-sm bg-gradient-manual"
}
const _hoisted_57 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "text-center text-uppercase text-secondary text-xxs" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = ["onUpdate:modelValue"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { key: 0 }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = ["onUpdate:modelValue"]
const _hoisted_70 = ["onClick"]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { class: "text-sm" }
const _hoisted_73 = { class: "form-check form-switch" }
const _hoisted_74 = ["onChange", "onUpdate:modelValue"]
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}, null, -1)
const _hoisted_76 = ["onClick"]
const _hoisted_77 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-eye text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_80 = ["onClick"]
const _hoisted_81 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-trash text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_82 = [
  _hoisted_81
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_argon_button = _resolveComponent("argon-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.searchItem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.searchCall(_ctx.searchIKey,_ctx.searchQuery)), ["enter"])),
                placeholder: "Procurar..."
              }, null, 544), [
                [_vModelText, _ctx.searchQuery]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.searchItemTime)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "datetime-local",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQueryTime) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.searchQueryTime]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_argon_button, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchCall(_ctx.searchIKey, _ctx.searchQueryTime))),
                  variant: "gradient",
                  color: "success",
                  fullWidth: "",
                  size: "medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("table", _hoisted_15, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_16, [
                _createElementVNode("span", {
                  innerHTML: _ctx.iconSort('numero_pedido')
                }, null, 8, _hoisted_17),
                _hoisted_18,
                _createElementVNode("span", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortData('numero_pedido')))
                }, " Pedido "),
                _createElementVNode("i", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchData('numero_pedido'))),
                  class: "fas fa-search pesquisa"
                })
              ]),
              _createElementVNode("th", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sortData('id_operacao'))),
                class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-1"
              }, [
                _createElementVNode("span", {
                  innerHTML: _ctx.iconSort('id_operacao')
                }, null, 8, _hoisted_19),
                _hoisted_20,
                _createElementVNode("i", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchData('id_operacao'))),
                  class: "fas fa-search pesquisa"
                })
              ]),
              _hoisted_21,
              _createElementVNode("th", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("i", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.searchData('cupom_fiscal'))),
                  class: "fas fa-search pesquisa"
                })
              ]),
              _hoisted_24,
              _createElementVNode("th", {
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sortData('tipo'))),
                class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              }, "Tipo"),
              _createElementVNode("th", {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sortData('id_operacao'))),
                class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              }, "Status"),
              _hoisted_25,
              _createElementVNode("th", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("i", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.searchTime('janela_entrega_inicio'))),
                  class: "fas fa-search pesquisa"
                })
              ]),
              _hoisted_28
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (pedido) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: _normalizeClass(`atencao-${pedido.status=='ATENÇÃO'?'warning':'ok'}`)
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("h6", _hoisted_31, _toDisplayString(pedido.numero_pedido), 1),
                      _createElementVNode("p", _hoisted_32, _toDisplayString(pedido.brand), 1)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_33, [
                  _createElementVNode("span", _hoisted_34, _toDisplayString(pedido.id_operacao), 1)
                ]),
                _createElementVNode("td", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "cap-input-local",
                      onChange: ($event: any) => (pedido.editingcapacidade=true),
                      "onUpdate:modelValue": ($event: any) => ((pedido.capacidade) = $event),
                      onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.doUpdate($event, pedido)), ["prevent"]), ["enter"]),
                      placeholder: "Digite a capacidade"
                    }, null, 40, _hoisted_37), [
                      [_vModelText, pedido.capacidade]
                    ]),
                    (pedido.editingcapacidade)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: "fas fa-save text-danger",
                          style: {"cursor":"pointer","margin-top":"9px"},
                          onClick: ($event: any) => (_ctx.doUpdate({}, pedido))
                        }, null, 8, _hoisted_38))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "cap-input-cupom",
                      "onUpdate:modelValue": ($event: any) => ((pedido.cupom_fiscal) = $event),
                      onChange: ($event: any) => (pedido.editingcupom=true),
                      onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.doUpdateUnico($event, pedido)), ["prevent"]), ["enter"]),
                      placeholder: "Cupom Fiscal"
                    }, null, 40, _hoisted_41), [
                      [_vModelText, pedido.cupom_fiscal]
                    ]),
                    (pedido.editingcupom)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: "fas fa-save text-danger",
                          style: {"cursor":"pointer","margin-top":"9px"},
                          onClick: ($event: any) => (_ctx.doUpdateUnico({}, pedido))
                        }, null, 8, _hoisted_42))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pedido.embalagens, (tag, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: index,
                        class: "tag"
                      }, [
                        _createTextVNode(_toDisplayString(tag.codigo_embalagem) + " ", 1),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.removeTag(pedido, tag.id_embalagem)),
                          class: "remove-btn"
                        }, "×", 8, _hoisted_45)
                      ]))
                    }), 128)),
                    _withDirectives(_createElementVNode("input", {
                      type: "numeric",
                      "onUpdate:modelValue": ($event: any) => ((pedido.textTag) = $event),
                      onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.addTag(pedido)), ["prevent"]), ["enter"]),
                      placeholder: "Digite e pressione Enter",
                      class: "tag-input"
                    }, null, 40, _hoisted_46), [
                      [_vModelText, pedido.textTag]
                    ]),
                    ( pedido.error)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "tag-erro",
                          innerHTML: pedido.error
                        }, null, 8, _hoisted_47))
                      : _createCommentVNode("", true),
                    ( pedido.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_48, _hoisted_50))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", _hoisted_51, [
                  _createElementVNode("span", {
                    class: _normalizeClass(`d-flex flex-column badge badge-sm bg-${pedido.tipo=='entrega'?'success':'info'}`)
                  }, _toDisplayString(pedido.tipo), 3)
                ]),
                _createElementVNode("td", _hoisted_52, [
                  (pedido.id_rota)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_53, "ALOCADO"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_54, "sem rota")),
                  (pedido.manual)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_55, "MANUAL"))
                    : _createCommentVNode("", true),
                  (pedido.status=='ATENÇÃO')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_56, "VERIFICAR COORDENADAS"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_57, [
                  (pedido.rota)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(pedido.rota.veiculo.modelo), 1))
                    : _createCommentVNode("", true),
                  _hoisted_59,
                  (pedido.rota)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(pedido.rota.veiculo.marca), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_61, [
                  _createElementVNode("div", null, [
                    (!pedido.editInicio)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                          _createTextVNode(_toDisplayString(_ctx.fDate(pedido.janela_entrega_inicio)) + " ", 1),
                          _createElementVNode("i", {
                            class: "fas fa-edit text-warning",
                            "aria-hidden": "true",
                            onClick: ($event: any) => (pedido.editInicio = true)
                          }, null, 8, _hoisted_63)
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "datetime-local",
                            class: "local-edit",
                            "onUpdate:modelValue": ($event: any) => ((pedido.janela_entrega_inicio) = $event)
                          }, null, 8, _hoisted_64), [
                            [_vModelText, pedido.janela_entrega_inicio]
                          ]),
                          _createElementVNode("i", {
                            class: "fas fa-check text-success big-btn",
                            onClick: ($event: any) => (_ctx.editJanela(pedido, 'inicio'))
                          }, null, 8, _hoisted_65),
                          _createElementVNode("i", {
                            class: "fas fa-times text-danger big-btn",
                            onClick: ($event: any) => (_ctx.CanceleditJanela(pedido, 'inicio'))
                          }, null, 8, _hoisted_66)
                        ], 64))
                  ]),
                  _createElementVNode("div", null, [
                    (!pedido.editFim)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_67, [
                          _createTextVNode(_toDisplayString(_ctx.fDate(pedido.janela_entrega_fim)) + " ", 1),
                          _createElementVNode("i", {
                            class: "fas fa-edit text-warning",
                            "aria-hidden": "true",
                            onClick: ($event: any) => (pedido.editFim = true)
                          }, null, 8, _hoisted_68)
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "datetime-local",
                            class: "local-edit",
                            "onUpdate:modelValue": ($event: any) => ((pedido.janela_entrega_fim) = $event)
                          }, null, 8, _hoisted_69), [
                            [_vModelText, pedido.janela_entrega_fim]
                          ]),
                          _createElementVNode("i", {
                            class: "fas fa-check text-success big-btn",
                            onClick: ($event: any) => (_ctx.editJanela(pedido, 'fim'))
                          }, null, 8, _hoisted_70),
                          _createElementVNode("i", {
                            class: "fas fa-times text-danger big-btn",
                            onClick: ($event: any) => (_ctx.CanceleditJanela(pedido, 'fim'))
                          }, null, 8, _hoisted_71)
                        ], 64))
                  ])
                ]),
                _createElementVNode("td", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "flexSwitchCheckDefault",
                      onChange: ($event: any) => (_ctx.doUpdate({}, pedido)),
                      "onUpdate:modelValue": ($event: any) => ((pedido.permitido) = $event)
                    }, null, 40, _hoisted_74), [
                      [_vModelCheckbox, pedido.permitido]
                    ]),
                    _hoisted_75
                  ]),
                  _createElementVNode("a", {
                    href: "javascript:;",
                    "data-bs-toggle": "tooltip",
                    onClick: ($event: any) => (_ctx.gotoPedido(pedido)),
                    "data-bs-original-title": "Preview product"
                  }, _hoisted_78, 8, _hoisted_76),
                  _hoisted_79,
                  _createElementVNode("a", {
                    href: "javascript:;",
                    "data-bs-toggle": "tooltip",
                    onClick: ($event: any) => (_ctx.removePedido(pedido)),
                    "data-bs-original-title": "Delete product"
                  }, _hoisted_82, 8, _hoisted_80)
                ])
              ], 2))
            }), 256))
          ])
        ])
      ])
    ])
  ]))
}